import ReactPDF, { PDFViewer, usePDF } from "@react-pdf/renderer"; // don't delete PDFViewer as it's used in the demo code at the bottom of the file
import React, { useContext, useEffect } from "react";
import classNames from "classnames";

// Context
import { UserContext } from "../../context/UserContext";
import { useCart } from "../../context/CartContext";
// Components
import Button from "../../components/common/Button";
import Label from "../../components/Label";
import Loading from "../../components/common/Loading";
import { Icon } from "../../components/Icon";
import CheckoutSummary from "./CheckoutSummary";
import CheckoutSuccess from "./CheckoutSuccess";
import CheckoutError from "./CheckoutError";
import CheckoutOrderFile from "./CheckoutOrderFile";
// Utils & Services
import { CartService } from "../../services/cart";
import { useAsync } from "../../utils/hooks/useAsync";

import "./CheckoutLayout.scss";

const CheckoutLayout = () => {
  const { user } = useContext(UserContext);
  const {
    cart,
    cartItems,
    hasGoldVariations,
    hasSilverVariations,
    getGoldVariations,
    getSilverVariations,
    isLoading,
    isLoadingCart,
  } = useCart();
  const {
    run,
    isLoading: isLoadingCheckout,
    isSuccess: isSuccessCheckout,
    isError: isErrorCheckout,
    isIdle: isPendingCheckoug,
  } = useAsync();

  const [pdfInstance, updateCheckoutOrderFile] = usePDF({
    document: (
      <CheckoutOrderFile
        user={user}
        cart={cart!}
        hasGoldVariations={hasGoldVariations}
        hasSilverVariations={hasSilverVariations}
        getGoldVariations={getGoldVariations}
        getSilverVariations={getSilverVariations}
      />
    ),
  });

  useEffect(() => {
    //@ts-ignore
    updateCheckoutOrderFile();
  }, [cart, user]);

  if (!cart) return <p>Error! No tenés elementos en tu carrito</p>;

  const handlePDFDownload = (e: any) => {
    e.preventDefault();
    if (pdfInstance.url) window.open(pdfInstance.url, "_blank");
  };

  const handleWppXO = async (e: any) => {
    e.preventDefault();
    
    // Create order in parallel (don't wait for it)
    CartService.createOrder(cartItems)
      .then(response => {
        console.log('Order created successfully:', response);
      })
      .catch(err => {
        console.error('Order creation failed:', err);
      });
    
    // Continue with XO checkout flow
    const xoPdfFormData = new FormData();
    console.log("trying to send pdf from ", pdfInstance.url);
    const xoPdfBlob = pdfInstance.blob;
    if (xoPdfBlob) {
      var file = new File([xoPdfBlob], "xopdffile.pdf", {
        lastModified: new Date().getTime(),
      });
      xoPdfFormData.append("xopdf", file, "xopdffile.pdf");
    }
    xoPdfFormData.append("user", JSON.stringify(user));

    await run(CartService.checkout(xoPdfFormData));
  };

  if (isLoadingCart || isLoading()) return <Loading />;

  return (
    <>
      <main className={classNames("checkout")}>
        {isSuccessCheckout ? <CheckoutSuccess /> : null}
        {isErrorCheckout ? <CheckoutError /> : null}
        {isPendingCheckoug ? (
          <>
            <Label className="checkout__header" tag="h1">
              Confirmá tu pedido
            </Label>
            <Label className="checkout__header-prompt" tag="h2">
              Tu orden está lista para ser enviada
            </Label>
            <CheckoutSummary />
            <p className="checkout__disclaimer">
              El precio final no incluye impuestos.
              <br />
              Los pesos de los productos son aproximados.
            </p>
            <Button
              className="checkout__wpp-cta"
              modifier="whatsapp"
              applyNewSize
              isLoading={isLoadingCheckout}
              onClick={handleWppXO}
            >
              <Icon iconName="wpp_icon" className="checkout__wpp-cta__icon" />
              <span>Enviar pedido por whatsApp</span>
            </Button>
            <p className="checkout__wpp-prompt">
              {`En tu WhatsApp (${user.phoneNumber})`}
              <br />
              verás la copia de la orden enviada.
            </p>
            <p className="checkout__pdf-prompt">
              También pueden enviarlo manualmente.
            </p>
            <Button
              modifier="tertiary"
              className="checkout__pdf-cta"
              applyNewSize
              onClick={handlePDFDownload}
            >
              Descargar el pedido en PDF
            </Button>
          </>
        ) : null}
      </main>
      {/**
       * Uncomment this to see the debug version of the PDF
     *       <PDFViewer style={{ width: "100%", minHeight: "600px" }}>
        <CheckoutOrderFile
          user={user}
          cart={cart}
          hasGoldVariations={hasGoldVariations}
          hasSilverVariations={hasSilverVariations}
          getGoldVariations={getGoldVariations}
          getSilverVariations={getSilverVariations}
        />
      </PDFViewer>
     */}
    </>
  );
};

export default CheckoutLayout;
